// extracted by mini-css-extract-plugin
var _1 = "ColorPickerPopoverSvSquare-moduleColorPickerPopoverSvSquare__IFpEI";
var _2 = "ColorPickerPopoverSvSquare-moduleblackLayer__VAb95";
var _3 = "ColorPickerPopoverSvSquare-modulepointer__MIs7a";
var _4 = "ColorPickerPopoverSvSquare-modulewhiteLayer__CSGzG";
export { _1 as "ColorPickerPopoverSvSquare", _2 as "blackLayer", _3 as "pointer", _4 as "whiteLayer" }
